import _ from 'lodash';

import googleReviews from 'assets/google-review-data.json';

import CONFIG from '../../../../app.config';
import { COUNTRY } from '../../../common/constants';

import { getOverallRating } from './rating-helpers';

export { getOverallRating };

export const reviewRatingMean = (reviews) => {
  if (reviews) {
    let total = 0;

    for (let i = 0; i < reviews.length; i += 1) {
      total += getOverallRating(reviews[i]);
    }

    const sum = total / reviews.length;

    return Math.round(sum * 10) / 10;
  }

  return 0;
};

export const combineAllReviews = (clinic) => {
  const clinicReviews = clinic?.reviews || [];
  const externalReviews = clinic?.externalReviews || [];
  const providerReviews =
    clinic?.providers?.map((provider) => provider.doctor.reviews).flat() || [];

  return [...clinicReviews, ...externalReviews, ...providerReviews]
    .filter(Boolean)
    .sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB - dateA;
    });
};

export const formatAverageRating = (averageRating) =>
  (averageRating && _.isNumber(averageRating)
    ? (Math.round(averageRating * 10) / 10).toFixed(1)
    : 0);

export const getInNetworkStatus = (planId, insurancePlans) =>
  Array.isArray(insurancePlans) && insurancePlans.some((planOrId) => (typeof planOrId === 'number' ? planOrId === planId : planOrId?.id === planId));

export const getAggregateReviewData = ({ clinicId, opencareReviews }) => {
  const opencareReviewsCount = opencareReviews.length;
  const opencareReviewsRating = reviewRatingMean(opencareReviews);

  const googleReviewsCount = _.get(googleReviews[clinicId], 'count', 0);
  const googleReviewsRating = _.get(googleReviews[clinicId], 'rating', 0);

  const aggregateReviewsCount = opencareReviewsCount + googleReviewsCount;
  // Computed weighted average of ratings from both sources
  const aggregateReviewsRating =
    (opencareReviewsRating * opencareReviewsCount
      + googleReviewsRating * googleReviewsCount)
    / aggregateReviewsCount;

  return {
    count: aggregateReviewsCount,
    rating: aggregateReviewsRating,
    sources:
      Math.min(opencareReviewsCount, 1) + Math.min(googleReviewsCount, 1),
  };
};

export const filterProviderPhotos = (result) =>
  (_.get(result, 'providers') || [])
    .filter((provider) => provider.onlineBooking)
    .map((provider) => ({
      ...provider.doctor.primaryPhoto,
      altText: provider.doctor.name,
    }));

export const getResultLocation = (result) =>
  _.get(result, 'address.customNeighborhood')
  || _.get(result, 'address.neighborhood')
  || _.get(result, 'address.locality');

export const displayMiles = (result) =>
  _.get(result, 'address.country') !== COUNTRY.canada;

export const convertMetersToMiles = (meters) => (meters / 1609).toFixed(1);

export const convertMetersToKilometers = (meters) => (meters / 1000).toFixed(1);

export const getAndFilterLanguages = (providers) => {
  if (!providers) {
    return [];
  }
  const languagesSpoken = [];
  providers.map((provider) =>
    provider.doctor.languages.map((language) =>
      languagesSpoken.push(language.name)));
  return [...new Set(languagesSpoken)].sort();
};

export const checkTimeSlotsWidgetEnabled = (slotsByDay, state, locality) => {
  const slotsCount = Object.values(slotsByDay || {}).flat().length;
  const stateValid =
    CONFIG.MATCH_RESULTS_TIME_SLOTS_WIDGET_STATES === '*'
    || CONFIG.MATCH_RESULTS_TIME_SLOTS_WIDGET_STATES.some(
      (configState) => configState.toLowerCase() === state.toLowerCase(),
    );
  const localityValid =
    CONFIG.MATCH_RESULTS_TIME_SLOTS_WIDGET_LOCALITIES === '*'
    || CONFIG.MATCH_RESULTS_TIME_SLOTS_WIDGET_LOCALITIES.some(
      (configLocality) => configLocality.toLowerCase() === locality.toLowerCase(),
    );

  return (
    CONFIG.MATCH_RESULTS_TIME_SLOTS_WIDGET === true
    && slotsCount > 0
    && stateValid
    && localityValid
  );
};
